import React, {FC} from 'react';
import {HEADER} from '@optimaxdev/analytics/mobile';
import {Link} from 'react-router-dom';
import {sendAnalytics} from 'libs/analytics/sendAnalytics';
import {CloudinaryImage} from '../cloudinaryImage/cloudinaryImage';
import classNames from 'classnames';

import s from './quickStartGuideLink.scss';

type PropsType = {
    mountStyle: 'quickStartGuideCategoryRow' | 'quickStartGuideMenu';
    isHPChipsExpEnabled?: boolean;
};

/**
 * Quick Start Guide Link to start guide page
 * @param {PropsType} props - mountStyle for the link
 * @returns {React.ReactElement} component
 */
export const QuickStartGuideLink: FC<PropsType> = ({
    mountStyle = 'quickStartGuideMenu',
    isHPChipsExpEnabled = false,
}) => {
    const clickHandler = () => {
        const startGuideLocation = mountStyle === 'quickStartGuideMenu' ? 'Menu' : 'Bubble Tab';
        const label = `Open - ${startGuideLocation}`;
        sendAnalytics(HEADER.START_GUIDE, {label});
    };

    return (
        <Link
            to="/start-guide"
            className={classNames(s[mountStyle], {[s.expCategoryRow]: isHPChipsExpEnabled})}
            onClick={clickHandler}
            aria-label="Start guide"
        >
            {isHPChipsExpEnabled ? (
                <>
                    <CloudinaryImage
                        src={require('../../features/experiments/hpChips/imagesVarA/start-guide.jpg')}
                        alt="start-guide"
                    />
                    <p className={s.expLinkText}>Start Guide</p>
                </>
            ) : (
                <>
                    Start Guide
                    {mountStyle === 'quickStartGuideMenu' && (
                        <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg">
                            <g fill="#89959c">
                                <path d="M8.75 16.5C4.477 16.5 1 13.023 1 8.75S4.477 1 8.75 1s7.75 3.477 7.75 7.75-3.477 7.75-7.75 7.75m0-16.5C3.925 0 0 3.925 0 8.75s3.925 8.75 8.75 8.75 8.75-3.925 8.75-8.75S13.575 0 8.75 0" />
                                <path d="M7.9 5.198h1.854v-1.6H7.9zM9.744 6.632H6.9v1.117l.99.19v4.26l-.894.19v1.11h3.637v-1.11l-.889-.19z" />
                            </g>
                        </svg>
                    )}{' '}
                </>
            )}
        </Link>
    );
};
